// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { DimensionIn } from './dimensionIn.zod.ts';

export const dimensionsInDimensionsMax = 10;

export const dimensionsInThresholdOneMax = 99;

export const DimensionsIn = zod.object({
  "dimensions": zod.array(DimensionIn).min(1).max(dimensionsInDimensionsMax),
  "threshold": zod.union([zod.int().min(1).max(dimensionsInThresholdOneMax),zod.null()]).optional()
});

export type DimensionsIn = zod.input<typeof DimensionsIn>;
export type DimensionsInOutput = zod.output<typeof DimensionsIn>;
